export const RA_ROUTING_SET_VALUE = 'raOptimal/routing/setValue/';

export const ACTIVE_PAGE_INDEX_SET_VALUE = RA_ROUTING_SET_VALUE + 'activePageIndex';
export const setActivePageIndex = value => ({ type: ACTIVE_PAGE_INDEX_SET_VALUE, value });

export const RESET_ROUTING = RA_ROUTING_SET_VALUE + 'resetState';
export const resetRouting = () => ({type: RESET_ROUTING});